// BookGraph.js
import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import 'chart.js/auto';

const BookGraph = ({ book }) => {
  const [priceHistory, setPriceHistory] = useState([]);

  // Update graph data when book prop changes
  useEffect(() => {
    if (book && book.price) {
      setPriceHistory((prev) => {
        const newEntry = { time: new Date().toLocaleTimeString(), price: parseFloat(book.price) };
        // Avoid duplicates: if price didn't change, skip
        if (prev.length > 0 && prev[prev.length - 1].price === newEntry.price) return prev;
        return [...prev.slice(-9), newEntry]; // keep last 10 entries
      });
    }
  }, [book.price]); // trigger only when price changes

  const data = {
    labels: priceHistory.map((p) => p.time),
    datasets: [
      {
        label: `${book.title} Price (Fanon)`,
        data: priceHistory.map((p) => p.price),
        fill: false,
        backgroundColor: 'rgba(54, 162, 235, 0.8)',
        borderColor: 'rgba(54, 162, 235, 1)',
        tension: 0.3,
      },
    ],
  };

  return (
    <div className="book-graph">
      <Line data={data} />
    </div>
  );
};

export default BookGraph;
